exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card {\n  margin: 3rem;\n  margin-top: 7rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/json-form/compc/json-form-cont/json-form-cont.component.scss
// module id = ../../../../../src/app/json-form/compc/json-form-cont/json-form-cont.component.scss
// module chunks = main